import type {CampaignADto} from '@cohort/admin-schemas/campaign';
import {DigitalAssetVisual} from '@cohort/merchants/components/DigitalAssetVisual';

const RewardSectionContent: React.FC<{campaign: CampaignADto}> = ({campaign}) => (
  <div className="flex items-center gap-2">
    <DigitalAssetVisual
      digitalAssetImageFileKey={campaign.digitalAssetCollection?.imageFileKey ?? null}
      animationFileKey={campaign.digitalAssetCollection?.animationFileKey ?? null}
      className="rounded-md border border-slate-100"
      size={24}
    />
    <span className="font-medium">{campaign.digitalAssetCollection?.internalName}</span>
  </div>
);

export default RewardSectionContent;
